<template>
    <div id="editor_novel">
        <div class="editor_novel">作品信息</div>
        <div class="editor_novel1">
            <div class="editor_novel2">
                <div class="editor_novel3">
                    <div class="editor_novel4">书号:</div>
                    <div class="editor_novel5">{{ novelInfo.id }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">作品名称:</div>
                    <div class="editor_novel5">{{ novelInfo.name }}</div>
                </div>
                <div class="editor_novel3" v-if="novelInfo.sex">
                    <div class="editor_novel4">核心受众:</div>
                    <div class="editor_novel5">{{ novelInfo.name }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">作品类型:</div>
                    <div class="editor_novel5">{{ novelInfo.typeName }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">作品标签:</div>
                    <div class="editor_novel5">{{ novelInfo.labels }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">文笔风格:</div>
                    <div class="editor_novel5">{{ novelInfo.style }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">写作视角:</div>
                    <div class="editor_novel5">{{ novelInfo.view }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">篇幅设定:</div>
                    <div class="editor_novel5">{{ novelInfo.length }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">作品状态:</div>
                    <div class="editor_novel5">{{ novelInfo.status == 0 ? '连载中' : "已完结" }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">结局:</div>
                    <div class="editor_novel5">{{ novelInfo.done == 'open' ? '开放结局' : "完整结局" }}</div>
                </div>
            </div>

            <div class="editor_novel6">
                <div class="editor_novel7">世界观:</div>
                <div class="editor_novel8">{{ novelInfo.world }}</div>
            </div>
            <div class="editor_novel6">
                <div class="editor_novel7">金手指:</div>
                <div class="editor_novel8">{{ novelInfo.goldfinger }}</div>
            </div>
            <div class="editor_novel6">
                <div class="editor_novel7">主线剧情:</div>
                <div class="editor_novel8">{{ novelInfo.plot }}</div>
            </div>
            <div class="editor_novel6">
                <div class="editor_novel7">角色信息:</div>
                <div class="editor_novel8">{{ novelInfo.protagonists }}</div>
            </div>
            <div class="editor_novel6">
                <div class="editor_novel7">作品简介:</div>
                <div class="editor_novel8">{{ novelInfo.introduction }}</div>
            </div>
            <div class="editor_novel6" v-if="novelInfo.requirement">
                <div class="editor_novel7">作品要求:</div>
                <div class="editor_novel8">{{ novelInfo.requirement }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api/api';
export default {
    data() {
        return {
            novelInfo: {}
        }
    },
    created(){
        let editItem = JSON.parse(sessionStorage.getItem('editItem'))
        if(editItem && editItem.novelInfo){
            this.getNovelinfo(editItem.novelInfo.id)
        }
    },
    methods:{
        //获取小说信息
        getNovelinfo(id) {
            api.novelDetail(id).then((res) => {
                if (res.code == 200) {
                    this.novelInfo = res.data
                    // this.novelInfo.labels = res.data.labels.split(',')
                    // this.novelInfo.novelSex = res.data.novelSex || ''
                    // this.novelInfo.style = res.data.style ? res.data.style.split(',') : []
                    // this.novelInfo['length'] = res.data['length'] || ''
                }
            })

        }
    }
}
</script>

<style>
#editor_novel {
    height: 100%;
}

.editor_novel {
    width: 100%;
    height: 67px;
    font-size: 19px;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E6EBF0;
}

.editor_novel1 {
    width: 100%;
    height: calc(100% - 68px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor_novel2 {
    padding: 20px 15px 10px;
    border-bottom: 1px solid #E6EBF0;
}

.editor_novel3 {
    display: flex;
    margin-bottom: 10px;
}

.editor_novel4 {
    width: 80px;
    font-size: 17px;
    color: #666666;
}

.editor_novel5 {
    flex: 1;
    font-size: 17px;
    color: #111111;
}

.editor_novel6 {
    padding: 20px 15px 0;
    margin-bottom: 20px;
}

.editor_novel7 {
    font-weight: bold;
    font-size: 17px;
    color: #333333;
    margin-bottom: 10px;
}

.editor_novel8 {
    background: #F8F9FA;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px;
    font-size: 17px;
    color: #666666;
    padding: 13px;
}
</style>